export enum ImageTypes {
    Picture = "Picture",
    Image = "Image",
}

export interface Image {
    url: string;
    alt?: string;
    credit?: string;
    description?: string;
    mass?: string;
    showcaption?: boolean;
    sizes?: string[];
    srcset?: string[];
    type?: string;
    loading?: string;
    aspectRatio?: number;
    isAboveFold?: boolean;
    classNames?: string;
    aspects?: {
        ratio9x16?: {
            url: string;
        };
        ratio16x9?: {
            url: string;
        };
        ratio1x1?: {
            url: string;
        };
    };
}

interface Source {
    srcset?: string;
    media?: string;
}

export interface PictureProps extends Image {
    imageType: ImageTypes.Picture;
    sources?: Source[];
}

export interface ImageProps extends Image {
    imageType: ImageTypes.Image;
}

export type ImageWrapperProps = ImageProps | PictureProps;
